<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'domains.editDomainHeader' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close(undefined)" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form" (submit)="submit()">
      <div class="form-field">
        <label class="field-label">{{ 'domains.googleAdminEmail' | translate }}</label>
        <mat-form-field appearance="outline">
          <input type="email" matInput formControlName="googleAdminEmail" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['googleAdminEmail'])">
            {{ 'fieldRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="form.hasError('email', ['googleAdminEmail'])">
            {{ 'emailInvalid' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close(undefined)" [disabled]="sendingRequest">{{ 'cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="submit()" [disabled]="sendingRequest">
      <mat-icon *ngIf="!sendingRequest">save</mat-icon>
      <mat-spinner diameter="20" class="dc-btn-spinner" *ngIf="sendingRequest"></mat-spinner>
      <span *ngIf="!sendingRequest">{{ 'save' | translate }}</span>
    </button>
  </footer>
</div>
